<template>
    <article>
        <p>
            Pg-agent can gather metrics from Postgres servers starting from version 9.6.
            It requires a database user with the assigned <var>pg_monitor</var> role.
            You will also need to enable the <var>pg_stat_statement</var> extension.
        </p>

        <CodeSnippet>
        <pre v-hl.sql>
create role &lt;USER&gt; with login password '&lt;PASSWORD&gt;';
grant pg_monitor to &lt;USER&gt;
create extension pg_stat_statements;
        </pre>
        </CodeSnippet>

        <p>
            Then, run the agent:
        </p>

        <CodeSnippet>
        <pre v-hl.sh>
docker run --detach --name coroot-pg-agent \
  --env DSN="postgresql://&lt;USER&gt;:&lt;PASSWORD&gt;@&lt;HOST&gt;:5432/postgres?connect_timeout=1&statement_timeout=30000" \
  ghcr.io/coroot/coroot-pg-agent
        </pre>
        </CodeSnippet>


        <p>Flags:</p>

        <pre v-hl.sh>
usage: coroot-pg-agent [&lt;flags&gt;] &lt;dsn&gt;

Flags:
      --listen="0.0.0.0:80"  Listen address (env: LISTEN) - "&lt;ip&gt;:&lt;port&gt;" or ":&lt;port&gt;".
      --scrape-interval=15s  How often to snapshot system views (env: PG_SCRAPE_INTERVAL).
      --version              Show application version.

Args:
  &lt;dsn&gt;  Data source name (env: DSN) - "postgresql://&lt;user&gt;:&lt;password&gt;@&lt;host&gt;:5432/postgres?connect_timeout=1&statement_timeout=30000".
        </pre>

        <h3>Zalando Operator for Postgres</h3>

        <p>
            If you run Postgres in a Kubernetes cluster, you can deploy pg-agent as a sidecar container.
            Here is an example of the <var>sidecars</var> spec section
            for the <a href="https://github.com/zalando/postgres-operator" target="_blank">Postgres Operator by Zalando</a>:
        </p>

        <pre v-hl.yaml>
...
podAnnotations:
  prometheus.io/scrape: 'true'
  prometheus.io/port: '80'
sidecars:
- name: pg-agent
  image: "ghcr.io/coroot/coroot-pg-agent:latest"
  ports:
    - containerPort: 80
      protocol: TCP
  resources:
    requests:
      cpu: 100m
      memory: 100Mi
  env:
    - name: PGUSER
      valueFrom:
        secretKeyRef:
          name: postgres.product-pg.credentials
          key: username
    - name: PGPASSWORD
      valueFrom:
        secretKeyRef:
          name: postgres.product-pg.credentials
          key: password
    - name: DSN
      value: postgresql://$(PGUSER):$(PGPASSWORD)@127.0.0.1:5432/postgres
        </pre>
    </article>
</template>

<script>

export default {
}
</script>

<style scoped>
</style>
